import { ReactComponent as IconFavortieTrackTitle } from "assets/svg/favorite-track-title.svg";
import { SurveyTemplate } from "../../types";
import { getContestDefaults } from "../helpers";

export const playlistIdeas: SurveyTemplate = {
  icon: <IconFavortieTrackTitle />,
  title: "Playlist Ideas",
  description:
    "Gain playlist adds by asking fans what playlists should feature the new release.",
  templateId: "playlistIdeas",
  template: (v, formState) => ({
    fields: {
      description: {
        content: {
          en: formState.title,
        },
      },
      ...getContestDefaults(formState),
    },
    surveyQuestions: [
      {
        type: "TextQuestion",
        id: "question_1",
        multiline: true,
        variants: { mobile: "Headline4", desktop: "Headline3" },
      },
    ],
    ...(formState.hasSweeps === "Yes" && {
      flags: {
        showContestConfirmationMessage: true,
      },
    }),
  }),
  prompt: {
    promptId: (state) =>
      state.hasSweeps === "Yes"
        ? "pp-sweeps---p-0bb499"
        : "pp-playlist-i-e36486",
    fields: [
      {
        name: "title",
        type: "text",
        label: "What's the title of the release?",
        placeholder: "Enter your answer...",
        getValidation: (fields) =>
          fields.title ? false : "This field cannot be left blank",
      },
      {
        name: "releaseDate",
        type: "text",
        label: "When will it be available (or is it already available)?",
        placeholder: "Enter your answer...",
        getValidation: (fields) =>
          fields.releaseDate ? false : "This field cannot be left blank",
      },
      {
        name: "hasSweeps",
        type: "radio",
        label: "Will you be offering a sweepstakes prize?",
        options: ["Yes", "No"],
        getValidation: (fields) =>
          !!fields.hasSweeps ? false : "You must select an option.",
      },
      {
        name: "prize",
        type: "text",
        label: "What's the prize?",
        placeholder: "Enter your answer...",
        getValidation: (fields) =>
          fields.prize || fields.hasSweeps === "No"
            ? false
            : "This field cannot be left blank",
        isVisible: (form) => form.hasSweeps === "Yes",
      },
    ],
  },
};
